import React, { useEffect, useState } from "react";
import { seleccionarOperadores } from "../../Services/asesores.services";

const Operador = ({ value, onChange, disabled }) => {
  const [operadores, setOperadores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    
    const cargarOperadores = async () => {
      try {
        setLoading(true);
        setError(false);

        const response = await seleccionarOperadores();

        // Soporta ambos formatos
        const data = response?.data?.data || response?.data || response?.data?.data;

        if (Array.isArray(data) && data.length > 0) {
          setOperadores(data);
        } else if (response?.data?.success) {
          setOperadores(response.data.data);
        } else {
          setError(true);
        }

      } catch (err) {
        console.error("Error cargando operadores:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    cargarOperadores();
  }, []);

  return (
    <div className="mb-3">
      <select
        name="operadorId"
        className="form-control"
        value={value}
        onChange={onChange}
        disabled={disabled || loading || error}
        required
      >
        {loading && <option value="">Cargando operadores...</option>}

        {!loading && error && (
          <option value="">Error cargando operadores</option>
        )}

        {!loading && !error && (
          <>
            <option value="">Selecciona operador</option>
            {operadores.map(op => (
              <option key={op.operadorId} value={op.operadorId}>
                {op.descripcion}
              </option>
            ))}
          </>
        )}
      </select>
    </div>
  );
};

export default Operador;